
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import AppBar from '@mui/material/AppBar'
import Switch from '@mui/material/Switch'
import { useStyles } from '../pages/Gui/gui'
import DropDown from './drop_down'
import { SocketContext } from '../contexts/socket';
import dayjs from 'dayjs'
import LogoutButton from './logout_button'
import { LatencyIndicator } from './latency_indicator_b'
import { LatencyIndicator as LatencyIndicatorA } from './latency_indicator'
import { useAuth } from '../contexts/AuthContext'
import AddSemidsButton from './add_semids'
import DisplayUTDate from './display_uttime'
import NightStatus from './night_status'
import { Container } from '@mui/material'


interface UserInfo {

}

interface Props {
  darkState?: boolean
  loggedIn?: boolean
  handleThemeChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  userinfo?: UserInfo
}

export default function FooterBar(props: Props) {
  const classes = useStyles();

  const date = dayjs.utc().format('YYYY-MM-DD') //remember to use ut date
  const { user, loggedIn } = useAuth()
  const user_firstname = user?.first;

  return (
    <AppBar
      position="fixed"
      style={{ bottom: "0", top: "unset" }}
      className={classes.appBar}
    >
      <Toolbar
        className={classes.toolbar}
      >
        <LatencyIndicator />
        <NightStatus props={props.darkState} />
        <Typography
          component="h3"
          variant="subtitle1"
          noWrap
          sx={{ textAlign: 'right' }}
          className={classes.title}
        >
        </Typography>
        <DisplayUTDate />
        {loggedIn ?
          <>
            <Typography sx={{ color: '#ddd', paddingLeft: '1em' }}>
              | {user?.first} {user?.last}&nbsp;
              | {user?.userid}
            </Typography>
            <Typography>
              <LogoutButton />
            </Typography>
          </>
          : ("")}
      </Toolbar>
    </AppBar>
  )
}
